export const IMG_CACHE = {
    name: 'image-cache',
    expirationDays: 7,
    maxSize: 100,
    timestampKey: 'timestamp',
}